import { forwardRef } from 'react';
import clsx from 'clsx';

const Container = forwardRef(({ className, ...rest }, ref) => (
  <div ref={ref} className={clsx('container', className)} {...rest} />
));

const ContainerFluid = forwardRef(({ className, ...rest }, ref) => (
  <Container ref={ref} className={clsx('max-w-full', className)} {...rest} />
));

const Wrapper = forwardRef(({ className, ...rest }, ref) => (
  <div ref={ref} className={className} {...rest} />
));

const Overlay = forwardRef(({ className, ...rest }, ref) => (
  <div ref={ref} className={className} {...rest} />
));

const Section = forwardRef(({ className, ...rest }, ref) => (
  <section
    ref={ref}
    className={clsx('section relative', className)}
    {...rest}
  />
));

const Article = forwardRef(({ className, ...rest }, ref) => (
  <article ref={ref} className={clsx('article', className)} {...rest} />
));

const Aside = forwardRef(({ className, ...rest }, ref) => (
  <aside ref={ref} className={className} {...rest} />
));

const Figure = forwardRef(({ className, ...rest }, ref) => (
  <figure ref={ref} className={className} {...rest} />
));

const Header = forwardRef(({ className, ...rest }, ref) => (
  <header ref={ref} className={className} {...rest} />
));

const Nav = forwardRef(({ className, ...rest }, ref) => (
  <nav ref={ref} className={className} {...rest} />
));

const SeoTitle = forwardRef(({ className, ...rest }, ref) => (
  <h1 ref={ref} className={clsx('text-3xl font-medium', className)} {...rest} />
));

const Main = forwardRef(({ className, ...rest }, ref) => (
  <main ref={ref} className={className} {...rest} />
));

Main.displayName = 'MainElement';
SeoTitle.displayName = 'SeoTitleElement';
Nav.displayName = 'NavElement';
Header.displayName = 'HeaderElement';
Figure.displayName = 'FigureElement';
Aside.displayName = 'AsideElement';
Article.displayName = 'ArticleElement';
Section.displayName = 'SectionElement';
Overlay.displayName = 'OverlayElement';
Wrapper.displayName = 'WrapperElement';
ContainerFluid.displayName = 'ContainerFluidElement';
Container.displayName = 'ContainerElement';

export {
  Container,
  ContainerFluid,
  Wrapper,
  Overlay,
  Section,
  Article,
  Aside,
  Figure,
  Header,
  Nav,
  SeoTitle,
  Main,
};
